import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Navbar from "../../HomeScreen/Navbar";
import Footer from "../../HomeScreen/bottomsection/Footer";
import SideBarAccount from "./SideBarAccount";
import HowToShop from "./HowToShop";
import Promotion from "./Promotion";
import ReturnAndExchange from "./ReturnAndExchange";
import ShippingTracking from "./ShippingTracking";
import ProductAndPricing from "./ProductAndPricing";
import Security from "./Security";
import Payment from "./Payment";
import GiftBox from "./GiftAndCard";

import "./myAccountPrivilage.css";

function HelpCenterRoutes() {
  return (
    <>
      <Navbar />
      <main className="help-center-page">
        <div className="container help-center-shell">
          <div className="row">
            <aside className="col-md-3 help-center-sidebar">
              <SideBarAccount />
            </aside>
            <section className="col-md-9 help-center-right-panel" aria-live="polite">
              <div className="help-center-content-shell">
                <Switch>
                  <Route exact path="/how-to-shop" component={HowToShop} />
                  <Route exact path="/promotions" component={Promotion} />
                  <Route exact path="/about/return-and-exchange" component={ReturnAndExchange} />
                  <Route exact path="/about/Shipping-Tracking" component={ShippingTracking} />
                  <Route exact path="/about/Product-And-Pricing" component={ProductAndPricing} />
                  <Route exact path="/about/Security" component={Security} />
                  <Route exact path="/about/Payment" component={Payment} />
                  <Route exact path="/about/GiftBox" component={GiftBox} />
                  <Redirect to="/how-to-shop" />
                </Switch>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

export default HelpCenterRoutes;
